import React from "react";
import { TransitionablePortal, Modal, Button } from "semantic-ui-react";
import { animation, duration } from "../../utils/utils";
const NotificationModal = (props) => {
  return (
    <TransitionablePortal
      transition={{ animation, duration }}
      open={props.open}
      onClose={() => props.close()}
    >
      <Modal onClose={() => props.close()} size="small" open={true}>
        <Modal.Content>
          <div className="AdminProfileUpdatedContainer notification-modal">
            <div className="messageContainer">
              <h3>{props.messageOne}</h3>
              <h4>{props.messageTwo}</h4>
            </div>
            <div className="buttonContainer">
              <Button
                size="large"
                positive
                name="okButton"
                content="OK"
                onClick={() => props.close()}
              />
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </TransitionablePortal>
  );
};

export default NotificationModal;
